import { FormRichTextField, FormTextField } from '../../components';
import { TEXT_AREA_MAX_LENGTH } from '../../constants';

import type { EducationDescriptionFieldProps } from './types';

export default function EducationDescriptionField({
  formik,
  name,
  label,
  placeholder,
  disabled,
  readOnly,
  richText,
  saveField,
}: EducationDescriptionFieldProps) {
  if (richText) {
    return (
      <FormRichTextField
        disabled={disabled}
        formik={formik}
        label={label}
        maxLength={TEXT_AREA_MAX_LENGTH}
        name={name}
        onBlur={saveField}
        placeholder={placeholder}
        readOnly={readOnly}
        required
      />
    );
  }

  return (
    <FormTextField
      disabled={disabled}
      formik={formik}
      label={label}
      maxLength={TEXT_AREA_MAX_LENGTH}
      minRows={3}
      multiline
      name={name}
      onBlur={saveField}
      placeholder={placeholder}
      readOnly={readOnly}
      required
    />
  );
}
